import React, { Component } from 'react';
import classnames from 'classnames';
import { PRODUCT_BUILDER_MODES } from 'swag-client-common/utils/constants';
import { Button } from 'swag-client-common/components/ui/button';
import classes from './footer.scss';
class Footer extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }
  handleSaveClick() {
    const {
      popupMode,
      addAssociatedProduct,
      onClose
    } = this.props;
    const message = popupMode === PRODUCT_BUILDER_MODES.BUILD_MODE ? 'Associated product has been added successfully' : 'Associated product has been updated successfully';
    addAssociatedProduct(message);
    onClose();
  }
  render() {
    const {
      popupMode,
      isQuantityAmountValid
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.footer
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.rightSection, classes.sectionWrapper)
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.rowMobile)
    }, /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      onClick: this.handleSaveClick,
      className: classes.submit,
      disabled: !isQuantityAmountValid,
      dataButton: "AddAssociatedToCart"
    }, popupMode === PRODUCT_BUILDER_MODES.BUILD_MODE ? 'Add product' : 'Update'))));
  }
}
export default Footer;